<template>
  <div class="user-header">
    <div class="user-info">
      <div class="avatar">
        <van-icon name="manager-o"
                  color="#1989fa"
                  size="30" />
      </div>
      <div class="user-details">
        <div class="username">{{username}}</div>
        <div class="phone">{{userCode}}</div>
      </div>
    </div>
    <div class="logout"
         @click="handleLogout"></div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { removeToken } from '@/utils/auth';
import { getUrlSearchParams } from "@/utils/index.js";
export default {
  name: 'UserHeader',
  props: {
    username: {
      type: String,
      default: ''
    },
    userCode: {
      type: String,
      default: ''
    }
  },
  mounted() {
      this.loginOut()
  },
  methods: {
    ...mapActions(["LogOut"]),
     async loginOut() {
      console.log('页面路由：', this.$route)
      console.log('页面地址：', window.location)
      const pageUrl = window.location.href;
      const pageUrlParams = getUrlSearchParams(pageUrl)
      console.log('获取路径参数：', pageUrlParams)
      if(pageUrlParams.loginOut){
         try {
          const { status } = await this.LogOut()
          if (status == 200) {
            location.reload();
          }
        } catch (error) {
          removeToken();
          location.reload();
        }
      }
     },
    handleLogout() {
      this.$dialog.confirm({
        title: '提示',
        message: '确定退出登录吗？',
      }).then(async () => {
        try {
          const { status } = await this.LogOut()
          if (status == 200) {
            location.reload();
          }
        } catch (error) {
          removeToken();
          location.reload();
        }
      }).catch(() => {});
    }
  },
}
</script>

<style lang="less" scoped>
.backgroundImage(@name) {
  background: url("~@/assets/images/@{name}") no-repeat;
  background-size: 100% 100%;
}
.user-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 16px;
  color: white;

  .user-info {
    display: flex;
    align-items: center;

    .avatar {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50px;
      height: 50px;
      margin-right: 12px;
      background-color: #fff;
      border-radius: 50%;
    }

    .user-details {
      .username {
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 4px;
      }

      .phone {
        font-size: 14px;
        opacity: 0.8;
      }
    }
  }

  .logout {
    width: 38px;
    height: 38px;
    .backgroundImage("icon_logout.png");
  }
}
</style>